import React from "react";
import { Link } from "react-router-dom";

const EscalationMessage = ({ role, activeEscalation }) => {
  return (
    <div className="escalation-message-container">
      <i className="pi pi-briefcase briefcase-icon" />
      <strong className="escalation-message-title">
        This process has been escalated to HSP
      </strong>
      <div className="escalation-message-content">
        {!["GXM_ADMIN", "GXM_MANAGER", "GXM_USER"].includes(role)
          ? "We’re on it! You can keep track of updates in the Escalation tab."
          : "Take action as soon as possible."}
      </div>
      <Link
        className="request__link"
        to={`/escalations/${activeEscalation?.id}/conversation`}
      >
        View Details
      </Link>
    </div>
  );
};

export default EscalationMessage;
